var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMysteryBox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    focusable: "false",
    className: "chakra-icon css-5uobpg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.508 5.1688L18.1746 3.94433C16.1264 2.86946 15.1023 2.33203 14.0007 2.33203C12.899 2.33203 11.8749 2.86946 9.82666 3.94432L9.45132 4.1413L19.8615 10.09L24.5477 7.74691C23.7938 6.89311 22.5774 6.25476 20.508 5.1688Z",
    fill: "url(#paint0_linear_12148_8698)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3737 9.29043L20.709 11.6228V15.1654C20.709 15.6486 20.3172 16.0404 19.834 16.0404C19.3507 16.0404 18.959 15.6486 18.959 15.1654V12.4978L14.8757 14.5395V25.5534C15.7132 25.3448 16.6662 24.8447 18.1746 24.0531L20.508 22.8286C23.0183 21.5113 24.2734 20.8526 24.9704 19.669C25.6673 18.4854 25.6673 17.0126 25.6673 14.0669V13.9305C25.6673 11.7224 25.6673 10.3419 25.3737 9.29043Z",
    fill: "url(#paint1_linear_12148_8698)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1257 25.5534V14.5395L2.62756 9.29043C2.33398 10.3419 2.33398 11.7224 2.33398 13.9305V14.0669C2.33398 17.0126 2.33398 18.4854 3.03095 19.669C3.72791 20.8526 4.98304 21.5113 7.49331 22.8286L9.82666 24.0531C11.3351 24.8447 12.2881 25.3448 13.1257 25.5534Z",
    fill: "url(#paint2_linear_12148_8698)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.45363 7.74691L14.0007 13.0204L17.9803 11.0306L7.61264 5.10619L7.49333 5.1688C5.42395 6.25476 4.20754 6.89311 3.45363 7.74691Z",
    fill: "url(#paint3_linear_12148_8698)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12148_8698",
    x1: 15.5139,
    y1: 2.33203,
    x2: 15.5139,
    y2: 25.5534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2ABDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0497FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12148_8698",
    x1: 15.5139,
    y1: 2.33203,
    x2: 15.5139,
    y2: 25.5534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2ABDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0497FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12148_8698",
    x1: 15.5139,
    y1: 2.33203,
    x2: 15.5139,
    y2: 25.5534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2ABDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0497FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_12148_8698",
    x1: 15.5139,
    y1: 2.33203,
    x2: 15.5139,
    y2: 25.5534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2ABDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0497FD"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMysteryBox);
export default __webpack_public_path__ + "static/media/mystery-box.dc6cbca2dc7a2cc79880e8b80253249c.svg";
export { ForwardRef as ReactComponent };